import { MODULE } from "./showHideOrderFilter.actionTypes";

export const getSelectedFilter = (state) => state.getIn([MODULE, "selectedFilter"]);

export const getOptions = (state) => state.getIn([MODULE, "options"]);

export default {};
